// SEO text pod výpisem kategorie (spodní popis z administrace) — sbalený na nadpis
// a první odstavec, tlačítko Zobrazit více / méně. Text zůstává celý v HTML,
// JS jen přepíná třídu stavu, nastavuje výšku sbalení a přidává tlačítko.
const mySeoTextTexts = {
    cs: { more: "Zobrazit více", less: "Zobrazit méně" },
    sk: { more: "Zobraziť viac", less: "Zobraziť menej" },
};

// Výška prolnutí s tlačítkem (::after v category-seo-text.scss)
const mySeoTextFadeHeight = 120;

// Sbalit, jen když je celý text aspoň o tolik delší než sbalená výška
const mySeoTextMinRatio = 1.3;

function mySeoTextSetExpanded($block, expanded) {
    const texts = mySeoTextTexts[getShoptetDataLayer("language")] || mySeoTextTexts.cs;

    $block.toggleClass("is-collapsed", !expanded);
    $block.find(".myseo-toggle")
        .attr("aria-expanded", expanded ? "true" : "false")
        .text(expanded ? texts.less : texts.more);
}

// První textový blok za prvním nadpisem (bez nadpisu první blok vůbec)
function mySeoTextFirstBlock($block) {
    const $children = $block.children().not(".myseo-toggle");
    const $heading = $children.filter("h1, h2, h3, h4, h5, h6").first();
    const $after = $heading.length ? $heading.nextAll().not(".myseo-toggle") : $children;

    return $after.not("h1, h2, h3, h4, h5, h6").first();
}

// Výška sbalení = spodek prvního odstavce + prolnutí s tlačítkem
function mySeoTextUpdate($block) {
    const $toggle = $block.find(".myseo-toggle");
    if ($toggle.attr("aria-expanded") === "true") return;

    const block = $block.get(0);
    const $first = mySeoTextFirstBlock($block);

    $block.removeClass("is-collapsed");
    $toggle.prop("hidden", true);

    if (!$first.length) return;

    const firstBottom = $first.get(0).getBoundingClientRect().bottom - block.getBoundingClientRect().top;
    const collapsedHeight = Math.ceil(firstBottom + mySeoTextFadeHeight);

    if (block.offsetHeight < collapsedHeight * mySeoTextMinRatio) return;

    block.style.setProperty("--myseo-collapsed-height", collapsedHeight + "px");
    $block.addClass("is-collapsed");
    $toggle.prop("hidden", false);
}

function mySeoTextUpdateAll() {
    $(".category__secondDescription").each(function () {
        if ($(this).find(".myseo-toggle").length) {
            mySeoTextUpdate($(this));
        }
    });
}

// Výška pevné hlavičky, jak bude vidět po posunu nahoru. Hlavička se při scrollu
// dolů schovává nad okraj, proto se sčítají celošířkové fixed lišty naskládané
// od horního okraje (viditelné i schované) a k tomu přilepené sticky prvky.
function mySeoTextHeaderBottom() {
    const bars = [];

    $("body *").each(function () {
        if (this.offsetParent !== null) return;

        const rect = this.getBoundingClientRect();
        if (!rect.height || rect.top > window.innerHeight / 3 || rect.height > window.innerHeight / 3 || rect.width < window.innerWidth * 0.9) return;
        if (getComputedStyle(this).position !== "fixed") return;

        bars.push(this);
    });

    bars.sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    let fixedHeight = 0;
    bars.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        const nested = bars.some(function (other) {
            return other !== el && other.contains(el);
        });
        if (!nested && rect.top <= fixedHeight + 1) {
            fixedHeight += rect.height;
        }
    });

    let stickyBottom = 0;
    document.elementsFromPoint(window.innerWidth / 2, fixedHeight + 1).forEach(function (el) {
        for (let node = el; node && node !== document.body; node = node.parentElement) {
            if (getComputedStyle(node).position === "sticky") {
                stickyBottom = Math.max(stickyBottom, node.getBoundingClientRect().bottom);
            }
        }
    });

    return Math.max(fixedHeight, stickyBottom);
}

function mySeoTextInit() {
    $(".type-category .category__secondDescription").each(function (index) {
        const $block = $(this);
        if ($block.find(".myseo-toggle").length) return;

        if (!$block.attr("id")) {
            $block.attr("id", "category-seo-text-" + index);
        }

        $("<button type='button' class='myseo-toggle' aria-expanded='false' hidden></button>")
            .attr("aria-controls", $block.attr("id"))
            .appendTo($block);

        mySeoTextSetExpanded($block, false);
        mySeoTextUpdate($block);
    });
}

$(document).ready(function () {
    if (!$(".type-category .category__secondDescription").length) return;

    mySeoTextInit();

    // Webfont změní zalomení řádků — přepočítat po jeho načtení
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(mySeoTextUpdateAll);
    }

    $(document).on("click", ".category__secondDescription .myseo-toggle", function () {
        const $block = $(this).closest(".category__secondDescription");
        const expand = $(this).attr("aria-expanded") !== "true";

        mySeoTextSetExpanded($block, expand);

        // Šířka okna se mohla změnit, když byl blok rozbalený — výšku sbalení spočítat znovu
        if (!expand) {
            mySeoTextUpdate($block);
        }

        // Po sbalení zpět na začátek bloku, jen když by zůstal mimo obrazovku
        if (!expand) {
            const headerBottom = mySeoTextHeaderBottom();
            const rect = $block.get(0).getBoundingClientRect();

            if (rect.bottom < headerBottom + 16) {
                window.scrollTo({ top: window.scrollY + rect.top - headerBottom - 16 });
            }
        }
    });

    // Klávesnicí na odkaz ve schované části → rozbalit, ať je fokus vidět
    $(document).on("focusin", ".category__secondDescription.is-collapsed a", function () {
        mySeoTextSetExpanded($(this).closest(".category__secondDescription"), true);
    });

    // Po změně šířky se text přelomí jinak — přepočítat výšku sbalení
    let resizeTimer;
    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(mySeoTextUpdateAll, 150);
    });
});

// Filtr, řazení a stránkování překreslí obsah AJAXem
document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    mySeoTextInit();
});
